import React, { useEffect } from 'react'
import photo from '../../assets/images/photo3.jpg'
import AOS from 'aos'
import 'aos/dist/aos.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faJs,
  faHtml5,
  faCss3Alt,
  faReact,
  faMicrosoft,
  faDocker,
  faNodeJs,
  faGitAlt,
} from '@fortawesome/free-brands-svg-icons'
import {
  faDatabase,
  faCloud,
  faServer,
} from '@fortawesome/free-solid-svg-icons'
import { IconProp } from '@fortawesome/fontawesome-svg-core'

function About() {
  const experience = new Date().getFullYear() - 2016

  const skillItems = [
    { icon: faReact, title: 'React JS' },
    { icon: faReact, title: 'React Native' },
    { icon: faJs, title: 'TypeScript' },
    { icon: faNodeJs, title: 'Node.js' },
    { icon: faHtml5, title: 'HTML5' },
    { icon: faCss3Alt, title: 'CSS3' },
    { icon: faDocker, title: 'Docker' },
    { icon: faCloud, title: 'Azure' },
    { icon: faMicrosoft, title: '.NET' },
    { icon: faDatabase, title: 'SQL' },
    { icon: faGitAlt, title: 'Git' },
    { icon: faServer, title: 'Web API' },
  ]

  useEffect(() => {
    AOS.init({
      disable: window.innerWidth < 768,
    })
  }, [])

  return (
    <section className="about" id="aboutMe" data-aos="fade-up">
      <div className="about-container">
        <div className="section-header">
          <span className="section-tag">Know Me More</span>
          <h2 className="section-title">About Me</h2>
          <div className="section-line"></div>
        </div>

        <div className="about-content">
          <div className="about-image-wrapper" data-aos="fade-right">
            <img src={photo} alt="Freddy" className="about-image" />
            <div className="about-image-decoration"></div>
          </div>

          <div className="about-text" data-aos="fade-left">
            <h3>
              A passionate developer with {experience}+ years of experience
            </h3>
            <p>
              I'm a Systems Engineer by profession with extensive experience
              working as a Full-Stack Developer for multiple companies in the
              services and technology sector. I've contributed to various
              projects designing and developing databases, services, web APIs,
              and web and mobile applications applying best programming
              practices such as SOLID principles and design patterns.
            </p>
            <p>
              In recent years, my work has been focused on web and mobile
              development using ReactJS and React Native, where I've
              consolidated great expertise. Whether you're looking to build a
              new application or need help with an existing project, I'd love to
              hear from you.
            </p>

            <div className="skills-grid">
              {skillItems.map((item) => (
                <div key={item.title} className="skill-item">
                  <FontAwesomeIcon icon={item.icon as IconProp} />
                  <span>{item.title}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default About
